import React from 'react'
import StockDelete from "./StockDelete";
import StockEditContainer from "./StockEditContainer";

const StockActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <StockEditContainer stock={record} updater={updater} />
            <StockDelete stock={record} updater={updater} />
        </React.Fragment>
    )
}
export default StockActions